export interface PurchaseOrderHeader {
  id: string;
  orderNo: number;
  supplierKey: string;
  supplierName: string;
  supplierOrderNo: string;
  supplierOrderRef: string;
  productionProcessDescription: string;
  purchaseOrderStatus: string;
  orderType: string;
  currency: string;
  orderValue: number;
  dateOrdered: Date;
  dateEntered: Date;
  enteredBy: string;
  sellingCompany: string;
  promisedDate: Date;
  colour: string;
  deliveryAddress: string;
  pickingDocumentPrinted: string;
  pickingDocumentPrintedDate: Date;
  print: boolean;
  thirdPartyDespatch: boolean;
  salesOrderNo: number;
  salesOrderReference: string;
  replenishmentOrder: string;
  purchaseOrderConfirmed: string;
}
